module.exports = __webpack_public_path__ + "img/001.c077f554.png";